<template>
  <div class="relative flex flex-col" :class="[paddingClasses]">
    <slot></slot>
    <div class="sm:absolute inset-0 z-10" :class="{ 'sm:py-12': !boxOutside }">
      <div class="sm:container sm:h-full relative flex" :class="alignmentClasses">
        <div
          class="p-6 lg:px-12 lg:pt-16 bg-blackly sm:w-80 sm:min-h-[20rem] md:w-80 md:min-h-[20rem] lg:w-[28rem] lg:min-h-[28rem] xl:w-[30rem] xl:min-h-[30rem] flex flex-col items-start justify-center w-full"
          :class="[{ 'sm:sticky sm:top-1/4': hasScrollingContent }, { 'sm:-mt-12': boxOutside }]"
        >
          <div v-if="tag" class="text-br-green fluid-xs leading-tightest capitalize">{{ tag }}</div>
          <TagBtn
            v-if="secondaryCta.length"
            :to="secondaryCta[0].element?.uri"
            class="bg-br-green text-blackly hover:bg-white hover:border-white focus-visible:bg-white focus-visible:border-white inline-block"
          >
            {{ secondaryCta[0].text }}
          </TagBtn>
          <div
            class="lg:mt-4 mt-2 leading-tightest font-semibold text-white hyphens-auto"
            :class="headingSize === 'large' ? 'fluid-3xl md:fluid-5xl' : 'fluid-3xl'"
            data-test-id="heading"
            v-html="heading"
          ></div>
          <div
            v-if="teaser"
            class="text-copy fluid-base leading-relaxed font-light checkmark-bullets mt-4 text-white"
            v-html="teaser"
          ></div>
          <LinkField
            v-if="cta[0] && cta[0].text"
            :tracking-name="heading"
            v-bind="cta[0]"
            class="inline-block mt-8"
            :class="buttonPrimary ? 'btn-pill-green border-none' : 'btn-pill-outline-white'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LinkField from '@/components/common/LinkField';
import TagBtn from '@/components/common/TagBtn';

const props = defineProps({
  boxPosition: {
    type: String,
    default: 'topLeft',
  },
  tag: {
    type: String,
    default: '',
  },
  heading: {
    type: String,
    required: true,
  },
  headingSize: {
    type: String,
    default: 'default',
  },
  teaser: {
    type: String,
    default: '',
  },
  cta: {
    type: Array,
    default: () => [],
  },
  secondaryCta: {
    type: Array,
    default: () => [],
  },
  buttonPrimary: {
    type: Boolean,
    default: false,
  },
  boxOutside: {
    type: Boolean,
    default: false,
  },
  hasScrollingContent: {
    type: Boolean,
    default: false,
  },
});

const alignmentClasses = computed(() => {
  const position = props.boxPosition?.toLowerCase() ?? 'middleright';

  let vertical = 'items-end';
  if (position.includes('top')) {
    vertical = 'items-end md:items-start';
  } else if (position.includes('middle')) {
    vertical = 'items-end md:items-center';
  } else if (position === 'center') {
    vertical = 'items-end md:items-center';
  }

  let horizontal = 'justify-start';

  if (position.includes('right') || position === 'middleRight') {
    horizontal = 'justify-end';
  } else if (position === 'center') {
    horizontal = 'justify-center';
  }

  return `${vertical} ${horizontal}`;
});

const paddingClasses = computed(() => {
  if (!props.boxOutside || props.fullWidthTeaserLayout !== 'boxed') {
    return '';
  }

  if (props.boxPosition.includes('top')) {
    return 'sm:pt-12';
  } else if (props.boxPosition.includes('bottom')) {
    return 'sm:pb-12';
  } else {
    return 'sm:py-12';
  }
});
</script>
